import { render, staticRenderFns } from "./Msglist.vue?vue&type=template&id=c9b2cebe&scoped=true"
import script from "./Msglist.vue?vue&type=script&lang=js"
export * from "./Msglist.vue?vue&type=script&lang=js"
import style0 from "./Msglist.vue?vue&type=style&index=0&id=c9b2cebe&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b2cebe",
  null
  
)

export default component.exports